import { CmsResource } from './cms-resource.model';

export interface ImageResource extends CmsResource {
  data: {
    id: number;
    attributes: Image;
  };
}

export interface ImagesResource {
  data: {
    id: number;
    attributes: Image;
  }[];
}

export interface ImageLinkResource {
  id: number,
  url: string,
  image: {
    data: {
      id: number;
      attributes: Image;
    };
  }
}


export interface Image {
  url: string;
  placeholder?: string; // base64
  name?: string;
  mime?: string;
  ext?: string;
  alternativeText?: string;
  caption?: string;
  type?: ImageType;
}

export interface ImageLink {
  url?: string;
  image?: Image;
}

export interface ImageB2c {
  thumbUrl?: string;
  thumbData?: string;
  previewUrl?: string;
  detailUrl?: string;
  largeUrl?: string;
  type: ImageType;
  images?: ImageB2c[];
}

export enum ImageType {
  STD = 'STD', THREE_SIXTY = 'THREE_SIXTY'
}
